import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M3 1a1 1 0 00-1 1v13a1 1 0 001 1h10a1 1 0 001-1V5.5a1 1 0 00-.293-.707l-3.5-3.5A1 1 0 009.5 1zm1 2h5.086L12 5.914V14H4z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" fillRule="evenodd" /><path d="M9 2v4h4z" fillRule="evenodd" /><path d="M3 1a1 1 0 00-1 1v13a1 1 0 001 1h10a1 1 0 001-1V5.5a1 1 0 00-.293-.707l-3.5-3.5A1 1 0 009.5 1zm1 2h5.086L12 5.914V14H4z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" fillRule="evenodd" /><path d="M9 2v4h4z" fillRule="evenodd" /><path d="M8.553 10.316c-.467-.064-1.046-.104-1.531.276-.404.315-.777.713-1.106 1.017-.328.304-.652.438-.586.438H2.987v1H5.33c.582 0 .9-.368 1.264-.705.364-.338.731-.72 1.043-.963.106-.083.407-.124.78-.073.372.052.707.178 1.1.178.147 0 .217.037.325.13.108.091.23.25.365.444.135.194.28.42.498.623.218.204.546.381.922.381h.86v-1h-.86c-.099 0-.14-.019-.238-.111-.099-.092-.22-.262-.36-.463-.14-.2-.3-.433-.539-.637a1.518 1.518 0 00-.972-.367c-.033 0-.499-.103-.965-.168zM6.418 5.85c-.86 0-1.568.708-1.568 1.568 0 .86.708 1.568 1.568 1.568.86 0 1.569-.708 1.569-1.568 0-.86-.709-1.569-1.569-1.569zm0 1c.32 0 .569.248.569.568 0 .32-.249.568-.569.568a.561.561 0 01-.568-.568c0-.32.248-.569.568-.569z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /></g></svg>;
}

export default SvgComponent;